export default {"version": "85cb363"}



// WEBPACK FOOTER //
// ./src/_git_info.js